export const en = {
  newTag: 'New tag',
  tags: 'TAGS:',
  wentWrong: 'Something went wrong, please try again.',
  cantCreateTag:
    'This project is not configured to create new tags at this time.'
};

export type Translations = typeof en;
